import React, { FC } from "react";

import { useLabels } from "../Hooks/useLabels";

import { FourthStepInfoContainer } from "../FormElements";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import { LocationDto } from "../../../../Api/Model/LocationDto.csharp";
import { CreateBookingResponseDto } from "../../../../Api/Model/CreateBookingResponseDto.csharp";
import {RichTextArea} from "../RichTextArea/RichTextArea";

type CenterInformationType = {
  bookingResponse: CreateBookingResponseDto;
  centerName: string;
};

export const CenterInformation: FC<CenterInformationType> = ({
  bookingResponse,
  centerName,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;

  const phoneNumber = bookingResponse.centerPhoneNumber?.trim();
  const mapURLSearch = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${bookingResponse.centerAddressLine1},${bookingResponse.centerAddressLine2}` ??
      ""
  )}`;

  return (
    <FourthStepInfoContainer title={fourthStepLabels?.centerDetailsHeading ?? "Finn frem"} noDivider>
      <p>
        {centerName}
        <br />
        <a href={`${mapURLSearch}`} className="CenterInformation__bareLink">
          {bookingResponse.centerAddressLine1}
          <br />
          {bookingResponse.centerAddressLine2}
        </a>
      </p>
      {bookingResponse.centerPhoneNumber && (
        <div>
          <SvgIcon className="CenterInformation__icon" iconName="phone" />
          <a href={`tel: ${phoneNumber}`}>
            {phoneNumber}
          </a>
        </div>
      )}
      {bookingResponse.centerSummary && (
        <RichTextArea content={bookingResponse.centerSummary} />
      )}
    </FourthStepInfoContainer>
  );
};
